module.exports = __webpack_public_path__ + "static/media/5.753caf45.jpeg";